export enum EOrigemRecebimentoMercadoria {
  ImportacaoXML = 1,
  NotasContraCnpj = 2,
  ConsultaChave = 3,
  Manual = 4,
  PedidoCompra = 5,
MovimentacaoEstoque = 6,
}
